import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const IMAGES = {
  mainBook: "https://cdn.magicpatterns.com/uploads/v1QsaVpyY9GH4JQ5gaVfgx/ChatGPT_Image_27_ago_2026,_17_18_39.webp",
  packCompleto: "https://cdn.magicpatterns.com/uploads/pYiYocj2orM7TxQmykg8r4/ChatGPT_Image_27_ago_2026,_17_16_32.webp",
  bonus1: "https://cdn.magicpatterns.com/uploads/iTZkkpLUE3e6LsQYEsvkdQ/ChatGPT_Image_27_ago_2026,_18_19_26.webp",
  bonus2: "https://cdn.magicpatterns.com/uploads/65MtA98jpsW7xj65LQHk5G/ChatGPT_Image_27_ago_2026,_17_29_24.webp",
  bonus3: "https://cdn.magicpatterns.com/uploads/d3cryZbVaxu2SKdXnovqPQ/ChatGPT_Image_27_ago_2026,_18_21_33.webp",
  bonus4: "https://cdn.magicpatterns.com/uploads/hLfmvemPTEnGcXMUEK3B1y/Diseno_sin_titulo.jpg",
  bonus5: "https://cdn.magicpatterns.com/uploads/nAKZyikiLP9FfPqFyYFrui/Diseno_sin_titulo_(1).jpg",
  sample1: "https://cdn.magicpatterns.com/uploads/1ULH7f1FmH675nFxVrneGL/capture_260827_190244.webp",
  sample2: "https://cdn.magicpatterns.com/uploads/dgmtKHaUo8xWzxK2bTkTL5/capture_260827_190235.webp",
  sample3: "https://cdn.magicpatterns.com/uploads/waAh3auNGD1fAwoapocMQj/capture_260827_190158.webp",
  sample4: "https://cdn.magicpatterns.com/uploads/4FKGaBZFVNJRdVKWwvMjoH/capture_260827_190150.webp",
  sample5: "https://cdn.magicpatterns.com/uploads/tTWrussu1pQDMr7PaKPGj9/capture_260827_190141.webp",
  profeSofi: "https://cdn.magicpatterns.com/uploads/pDZyp7LwLPA3v1dh9UBmHD/9d15cd6a-1102-4c9f-beb8-0e12c0a6ab8d.webp"
};
const GameDecoration = ({
  type,
  className,
  style
}: {
  type: string;
  className?: string;
  style?: React.CSSProperties;
}) => {
  let svgContent = null;
  switch (type) {
    case 'pickaxe':
      svgContent = <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges" className="w-full h-full drop-shadow-[2px_2px_0px_rgba(17,17,17,1)]" data-id="element-0" data-mp="3dlns8ajhypvn">
          <path d="M14 2v4h-1V4h-2V3H7V2h7z" fill="#55FFFF" data-id="element-1" data-mp="stuczpk3sn7f" />
          <path d="M13 3v2h-1V4h-1V3h2z" fill="#FFFFFF" data-id="element-2" data-mp="swghthfm0oly" />
          <path d="M14 1h1v6h-1v1h-1v1h-1V8h1V6h1V2h-4v1H8v1H7v1H6V4h1V3h2V2h3V1h2z" fill="#111" data-id="element-3" data-mp="356rh3pi3e8j" />
          <path d="M11 5h2v2h-2V5zm-2 2h2v2H9V7zM7 9h2v2H7V9zM5 11h2v2H5v-2zM3 13h2v2H3v-2z" fill="#8B6346" data-id="element-4" data-mp="3ubztg9s4bhe4" />
          <path d="M10 6h1v1h-1V6zm-2 2h1v1H8V8zm-2 2h1v1H6v-1zm-2 2h1v1H4v-1zm-2 2h1v1H2v-1z" fill="#5C4033" data-id="element-5" data-mp="d45vg8zbmlp7" />
          <path d="M12 5h1v2h-1V5zm-2 2h1v2h-1V7zM8 9h1v2H8V9zM6 11h1v2H6v-2zM4 13h1v2H4v-2z" fill="#111" data-id="element-6" data-mp="83i3nl39q0tx" />
          <path d="M6 3h1v1H6V3zM12 9h1v1h-1V9z" fill="#111" data-id="element-7" data-mp="3gj1sm7wwox36" />
        </svg>;
      break;
    case 'diamond':
      svgContent = <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges" className="w-full h-full drop-shadow-[2px_2px_0px_rgba(17,17,17,1)]" data-id="element-8" data-mp="3qaxs9nen4v9i">
          <path d="M7 1h2v1h2v1h1v2h1v6h-1v2h-1v1h-2v1H7v-1H5v-1H4v-2H3V5h1V3h1V2h2V1z" fill="#111" data-id="element-9" data-mp="3limsqlntbbhh" />
          <path d="M7 2h2v1h2v1h1v2h1v5h-1v2h-1v1h-2v1H7v-1H5v-1H4v-2H3V6h1V4h1V3h2V2z" fill="#55FFFF" data-id="element-10" data-mp="2xsk4kgn0qpo5" />
          <path d="M6 3h3v1h1v1h1v2h-1V5H9V4H6V3z" fill="#FFFFFF" data-id="element-11" data-mp="18drjdvxkvfdt" />
          <path d="M11 7v4h-1v2h-2v1H7v-1h2v-1h1V7h1z" fill="#00AAAA" data-id="element-12" data-mp="18cgflw44u7mp" />
        </svg>;
      break;
    case 'emerald':
      svgContent = <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges" className="w-full h-full drop-shadow-[2px_2px_0px_rgba(17,17,17,1)]" data-id="element-13" data-mp="yflinhnicfaj">
          <path d="M6 1h4v2h2v2h1v6h-1v2h-2v2H6v-2H4v-2H3V5h1V3h2V1z" fill="#111" data-id="element-14" data-mp="13clobrgg3g14" />
          <path d="M6 2h4v2h2v2h1v4h-1v2h-2v2H6v-2H4v-2H3V6h1V4h2V2z" fill="#55FF55" data-id="element-15" data-mp="1r4seu9zhossm" />
          <path d="M6 3h3v1h1v2h-1V4H6V3z" fill="#FFFFFF" data-id="element-16" data-mp="1w211amro7izo" />
          <path d="M10 11v2H6v-1h4v-1z" fill="#00AA00" data-id="element-17" data-mp="1i3ujsh713vm6" />
        </svg>;
      break;
    case 'torch':
      svgContent = <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges" className="w-full h-full drop-shadow-[2px_2px_0px_rgba(17,17,17,1)]" data-id="element-18" data-mp="1m4ms9882twhe">
          <path d="M7 4h2v10H7V4z" fill="#111" data-id="element-19" data-mp="aq0umkchyrue" />
          <path d="M7 6h2v8H7V6z" fill="#8B6346" data-id="element-20" data-mp="aqslxiz2a3ev" />
          <path d="M7 4h2v2H7V4z" fill="#FFAA00" data-id="element-21" data-mp="qwvp67ht2b37" />
          <path d="M7 3h2v1H7V3z" fill="#FFFF55" data-id="element-22" data-mp="qyqbnq8q6b9e" />
          <path d="M7 2h2v1H7V2z" fill="#FFFFFF" data-id="element-23" data-mp="m6p1c9v4aum0" />
        </svg>;
      break;
    case 'grass-block':
      svgContent = <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges" className="w-full h-full drop-shadow-[2px_2px_0px_rgba(17,17,17,1)]" data-id="element-24" data-mp="h6sv03yy6r3a">
          <path d="M1 1h14v14H1V1z" fill="#111" data-id="element-25" data-mp="19vzylhd9e6ve" />
          <path d="M2 5h12v9H2V5z" fill="#8B6346" data-id="element-26" data-mp="19vhqnnh8i47n" />
          <path d="M2 2h12v3H2V2z" fill="#55A83C" data-id="element-27" data-mp="14x6h7duupvpy" />
          <path d="M2 2h12v1H2V2z" fill="#75C765" data-id="element-28" data-mp="14xg7l2jt64w6" />
          <path d="M2 5h1v1h2V5h2v2h2V5h2v1h2V5h1v1h-1v1h-1V6h-2v1H8V6H6v1H4V6H3v1H2V5z" fill="#55A83C" data-id="element-29" data-mp="zxk73dabkvld" />
        </svg>;
      break;
    case 'chest':
      svgContent = <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges" className="w-full h-full drop-shadow-[2px_2px_0px_rgba(17,17,17,1)]" data-id="element-30" data-mp="vybbe2vpynn6">
          <path d="M1 3h14v10H1V3z" fill="#111" data-id="element-31" data-mp="3gkwd2t0zc3d2" />
          <path d="M2 4h12v8H2V4z" fill="#A67B5B" data-id="element-32" data-mp="1w4osw9ym7gs8" />
          <path d="M2 4h12v1H2V4zm0 3h12v1H2V7zm0 4h12v1H2v-1zM2 4h1v8H2V4zm11 0h1v8h-1V4z" fill="#3A2418" data-id="element-33" data-mp="1w5zy8e7pkwlg" />
          <path d="M7 6h2v3H7V6z" fill="#111" data-id="element-34" data-mp="206a1hj4498wm" />
          <path d="M7 6h2v2H7V6z" fill="#CCCCCC" data-id="element-35" data-mp="254laxsqi1heb" />
        </svg>;
      break;
    case 'pig':
      svgContent = <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges" className="w-full h-full drop-shadow-[2px_2px_0px_rgba(17,17,17,1)]" data-id="element-36" data-mp="29w3dumc31s1x">
          <path d="M3 4h10v8H3V4z" fill="#111" data-id="element-37" data-mp="2jtr9dehij3l5" />
          <path d="M4 5h8v6H4V5z" fill="#FFAAFF" data-id="element-38" data-mp="2jsg57dk5ntti" />
          <path d="M6 8h4v2H6V8z" fill="#FF55FF" data-id="element-39" data-mp="2nvums8nqsi92" />
          <path d="M5 7h1v1H5V7zm4 0h1v1H9V7z" fill="#111" data-id="element-40" data-mp="2nw4crw8seper" />
          <path d="M4 7h1v1H4V7zm4 0h1v1H8V7z" fill="#FFFFFF" data-id="element-41" data-mp="2sv7jdl4f13ou" />
        </svg>;
      break;
    case 'gold':
      svgContent = <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges" className="w-full h-full drop-shadow-[2px_2px_0px_rgba(17,17,17,1)]" data-id="element-42" data-mp="timyz0y6p6wx">
          <path d="M5 3h6v2h2v6h-2v2H5v-2H3V5h2V3z" fill="#111" data-id="element-43" data-mp="21r2be4brwjq4" />
          <path d="M5 4h6v2h2v4h-2v2H5v-2H3V6h2V4z" fill="#FFAA00" data-id="element-44" data-mp="21tf153nrvydq" />
          <path d="M5 5h4v1h1v2h-1V6H5V5z" fill="#FFFF55" data-id="element-45" data-mp="1wu263vmqzl02" />
          <path d="M9 9v2H5V9h4z" fill="#AA5500" data-id="element-46" data-mp="2ass2ta5nninw" />
        </svg>;
      break;
    case 'trophy':
      svgContent = <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges" className="w-full h-full drop-shadow-[2px_2px_0px_rgba(17,17,17,1)]" data-id="element-47" data-mp="25sw7s0exr1kh">
          <path d="M4 2h8v5H4V2zm-2 2h2v3H2V4zm10 0h2v3h-2V4zm-7 5h2v4H5v-4zm-1 4h6v2H4v-2z" fill="#111" data-id="element-48" data-mp="2frlf4z97h3mh" />
          <path d="M5 3h6v3H5V3zm-2 2h1v1H3V5zm10 0h1v1h-1V5zm-6 4h2v3H7V9zm-2 4h6v1H5v-1z" fill="#FFAA00" data-id="element-49" data-mp="2tj9sf5v6xy51" />
          <path d="M5 3h2v1H5V3zm-2 2h1v1H3V5z" fill="#FFFF55" data-id="element-50" data-mp="2pgwlwf8mdw77" />
        </svg>;
      break;
    default:
      return null;
  }
  return <div className={`absolute pointer-events-none z-[1] ${className}`} style={style} data-id="element-51" data-mp="33hfrlfpm4q67">
      {svgContent}
    </div>;
};
const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = React.useState(30 * 60);
  React.useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 30 * 60);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60).toString().padStart(2, '0');
  const seconds = (timeLeft % 60).toString().padStart(2, '0');
  const today = new Date();
  const days = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  const dayName = days[today.getDay()];
  const day = today.getDate();
  const month = today.getMonth() + 1;
  return <div className="bg-[#111] pixel-border p-2 mt-3 w-full max-w-[350px] flex flex-col items-center justify-center relative overflow-hidden" data-id="element-52" data-mp="2pfh9bvybqw3s">
      <p className="font-body font-bold text-yellow-pixel text-[12px] uppercase text-center mb-1 relative z-10" data-id="element-53" data-mp="2uebs4xwakknw">
        ⚠️ Oferta válida solo hoy {dayName} {day}/{month}
      </p>
      <div className="flex items-center gap-2 font-display text-2xl text-white text-outline-sm relative z-10" data-id="element-54" data-mp="2kekx8v3tk3na">
        <div className="bg-[#2D3748] px-2 py-0.5 pixel-border min-w-[50px] text-center" data-id="element-55" data-mp="30uvg0qqj7gm4">{minutes}</div>
        <span className="text-yellow-pixel animate-pulse" data-id="element-56" data-mp="2vwu02eoejxev">:</span>
        <div className="bg-[#2D3748] px-2 py-0.5 pixel-border min-w-[50px] text-center" data-id="element-57" data-mp="2qwekdggnedtq">{seconds}</div>
      </div>
    </div>;
};
const CTAButton = ({
  text = "QUIERO ACCEDER AHORA 🎮",
  className = "",
  showTimer = true,
  showFeatures = false,
  href = "https://www.aprendejugando.shop/cart/43083545313355:1"
}) => <div className={`flex flex-col items-center w-full ${className}`} data-id="element-58" data-mp="2d5136967ps1v">
    <a href={href} className="btn-pixel w-full py-4 md:py-5 px-4 text-2xl md:text-3xl flex items-center justify-center text-center leading-tight shadow-[0_6px_0_#111] active:shadow-[0_0px_0_#111] active:translate-y-[6px] no-underline" data-id="element-59" data-mp="2866mbcrt2dke">
      {text}
    </a>
    {showTimer && <CountdownTimer data-id="element-60" data-mp="1yad2d8brbhsl" />}
    {showFeatures && <div className="flex flex-wrap justify-center gap-x-2 gap-y-1 mt-3 text-[12px] font-body font-bold text-[#111]" data-id="element-61" data-mp="1u6oueoj7qk6t">
        <span data-id="element-62" data-mp="9o4k350xsgxu">⚡ Acceso inmediato</span>
        <span data-id="element-63" data-mp="9r8syfpck0uu">·</span>
        <span data-id="element-64" data-mp="dq7zg4qq85oe">📄 PDF</span>
        <span data-id="element-65" data-mp="dpgednur9qcd">·</span>
        <span data-id="element-66" data-mp="dowvo4xa6xxa">🖨️ Imprimible</span>
        <span data-id="element-67" data-mp="ipktb9g0md0h">·</span>
        <span data-id="element-68" data-mp="ip2m5hrteeds">🔒 Pago seguro</span>
      </div>}
  </div>;
const AutoScrollCarousel = () => {
  const scrollRef = React.useRef<HTMLDivElement>(null);
  const [isHovered, setIsHovered] = React.useState(false);
  React.useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    let animationId: number;
    const scroll = () => {
      if (!isHovered) {
        el.scrollLeft += 1;
        if (el.scrollLeft >= el.scrollWidth / 2) {
          el.scrollLeft = 0;
        }
      }
      animationId = requestAnimationFrame(scroll);
    };
    animationId = requestAnimationFrame(scroll);
    return () => cancelAnimationFrame(animationId);
  }, [isHovered]);
  const samples = [IMAGES.sample1, IMAGES.sample2, IMAGES.sample3, IMAGES.sample4, IMAGES.sample5];
  return <div className="w-full relative py-8 overflow-hidden bg-minecraft-landscape bg-cover bg-center border-y-4 border-[#111]" data-id="element-69" data-mp="2f756wsfw5rag">
      <div className="absolute inset-0 bg-[#1A365D]/85" data-id="element-70" data-mp="2k5f57bwwx80a"></div>
      <motion.h2 initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className="font-display text-[26px] md:text-[32px] text-white text-outline text-center mb-8 uppercase relative z-10" data-id="element-71" data-mp="2k81d5cnptpj1">
        UN VISTAZO POR DENTRO 👀
      </motion.h2>
      <div ref={scrollRef} className="flex gap-6 overflow-x-auto hide-scrollbar px-4 pb-4 snap-x relative z-10" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} onTouchStart={() => setIsHovered(true)} onTouchEnd={() => setIsHovered(false)} data-id="element-72" data-mp="21gi68uqklrbq">
        {[...samples, ...samples, ...samples].map((src, i) => <div key={i} className="w-[260px] md:w-[320px] flex-shrink-0 bg-white pixel-border hard-shadow p-2 snap-center cursor-grab active:cursor-grabbing hover:-translate-y-2 transition-transform duration-300" data-id="element-73" data-mp="1do1qiqub2bfl" data-mpi={i}>
            <img src={src} alt={`Muestra ${i}`} className="w-full h-auto object-cover border-2 border-[#111]" data-id="element-74" data-mp="3rxx8mnyepzhw" />
          </div>)}
      </div>
      <div className="flex items-center justify-center gap-2 mt-2 text-white/70 font-body font-bold text-[11px] md:text-[12px] uppercase relative z-10" data-id="element-75" data-mp="3mxrcovl3tqu0">
        <span className="animate-pulse" data-id="element-76" data-mp="3i23lkan2anlv">←</span> Deslizá para ver más <span className="animate-pulse" data-id="element-77" data-mp="3d1fvpsakkct8">→</span>
      </div>
    </div>;
};
const SalesPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState({
    name: '',
    location: '',
    time: ''
  });
  const names = ['María', 'Laura', 'Florencia', 'Sofía', 'Camila', 'Valeria', 'Romina', 'Luciana', 'Paula', 'Daniela', 'Carolina', 'Mariana', 'Julieta', 'Agustina'];
  const locations = ['Palermo', 'Belgrano', 'Caballito', 'Recoleta', 'Córdoba', 'Rosario', 'Mendoza', 'Mar del Plata', 'La Plata', 'Almagro', 'Vicente López', 'San Isidro', 'Quilmes', 'Neuquén', 'Tucumán'];
  const times = ['hace 2 minutos', 'hace 5 minutos', 'hace 12 minutos', 'hace 1 hora', 'hace 3 minutos', 'hace 8 minutos', 'hace 15 minutos'];
  useEffect(() => {
    // Initial delay before first popup
    const initialTimer = setTimeout(() => {
      showRandomBuyer();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showRandomBuyer = () => {
    const randomName = names[Math.floor(Math.random() * names.length)];
    const randomLocation = locations[Math.floor(Math.random() * locations.length)];
    const randomTime = times[Math.floor(Math.random() * times.length)];
    setCurrentBuyer({
      name: randomName,
      location: randomLocation,
      time: randomTime
    });
    setIsVisible(true);

    // Hide after 5 seconds
    setTimeout(() => {
      setIsVisible(false);

      // Schedule next popup between 10 and 20 seconds later
      const nextDelay = Math.floor(Math.random() * 10000) + 10000;
      setTimeout(showRandomBuyer, nextDelay);
    }, 5000);
  };
  return <AnimatePresence data-id="element-78" data-mp="15pgan0bsskki">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: "spring",
      stiffness: 400,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 bg-white pixel-border hard-shadow-sm p-3 flex items-center gap-3 max-w-[300px]" data-id="element-79" data-mp="15oey0rf4vq0o">
          <div className="bg-grass-green w-10 h-10 flex-shrink-0 flex items-center justify-center pixel-border animate-gift-pop" data-id="element-80" data-mp="msov91zdmplq">
            <span className="text-xl" data-id="element-81" data-mp="wp1l1orswjb7">🎁</span>
          </div>
          <div className="flex flex-col" data-id="element-82" data-mp="wngs23l4x8fg">
            <p className="font-body font-bold text-[13px] text-[#171717] leading-tight" data-id="element-83" data-mp="2d2icsaqssyxm">
              <span className="text-grass-green font-black" data-id="element-84" data-mp="28472jywlcmev">{currentBuyer.name}</span> de {currentBuyer.location} acaba de comprar el pack.
            </p>
            <p className="font-body font-bold text-[11px] text-gray-500 mt-0.5" data-id="element-85" data-mp="hoeah6o3atb3">
              {currentBuyer.time}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
};
const Testimonials = () => {
  const scrollRef = React.useRef<HTMLDivElement>(null);
  const [isHovered, setIsHovered] = React.useState(false);
  React.useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    let animationId: number;
    const scroll = () => {
      if (!isHovered) {
        el.scrollLeft += 0.5;
        if (el.scrollLeft >= el.scrollWidth / 2) {
          el.scrollLeft = 0;
        }
      }
      animationId = requestAnimationFrame(scroll);
    };
    animationId = requestAnimationFrame(scroll);
    return () => cancelAnimationFrame(animationId);
  }, [isHovered]);
  const reviews = [{
    name: "Romina G.",
    role: "Mamá de 8 años",
    text: "literalmente es la primera vez que mi nene se sienta a hacer cuentas sin llorar jaja. le encantó lo de las pociones y los diamantes.",
    stars: 5,
    color: "bg-[#E6FFFA]"
  }, {
    name: "Valeria M.",
    role: "Docente",
    text: "soy profe de apoyo y este material me salvó la vida. los chicos ven los dibujos de minecraft y se re enganchan al toque.",
    stars: 5,
    color: "bg-[#FEFCBF]"
  }, {
    name: "Carlos D.",
    role: "Papá",
    text: "muy bueno la verdad, mi hijo de 9 años estaba re trabado con las multiplicaciones y con esto lo agarró como si fuera un juego.",
    stars: 5,
    color: "bg-[#EBF8FF]"
  }, {
    name: "Luciana P.",
    role: "Mamá",
    text: "lo imprimimos ayer a la tarde y ya completó como 5 hojas seguidas... no lo puedo creer jajaja súper recomendado.",
    stars: 5,
    color: "bg-[#FEEBC8]"
  }];
  return <section className="bg-off-white px-4 py-12 relative overflow-hidden" style={{
    paddingTop: "16px",
    paddingBottom: "23px"
  }} data-id="element-86" data-mp="23d8i9w574kco">
      <motion.h2 initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className="font-body font-black text-[26px] md:text-[32px] text-[#171717] text-center mb-8 uppercase relative z-10" data-id="element-87" data-mp="2zxh7a7er13bt">
        LO QUE DICEN OTRAS FAMILIAS
      </motion.h2>
      <div ref={scrollRef} className="flex gap-4 overflow-x-auto hide-scrollbar px-4 pb-4 snap-x relative z-10 w-full" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} onTouchStart={() => setIsHovered(true)} onTouchEnd={() => setIsHovered(false)} data-id="element-88" data-mp="jidrtc1ijvrn">
        {[...reviews, ...reviews, ...reviews].map((r, i) => <div key={i} className={`w-[260px] flex-shrink-0 ${r.color} pixel-border hard-shadow p-4 snap-center flex flex-col cursor-grab active:cursor-grabbing hover:-translate-y-1 transition-transform duration-300`} data-id="element-89" data-mp="fhaeoxauodu4" data-mpi={i}>
            <div className="flex text-yellow-pixel text-[22px] mb-2 drop-shadow-md" data-id="element-90" data-mp="5il7bygkybs4">
              {"★".repeat(r.stars)}
            </div>
            <p className="font-body font-medium text-[#302A26] text-[14px] leading-[1.4] mb-4 flex-grow" data-id="element-91" data-mp="1zw3zstvr746k">"{r.text}"</p>
            <div className="mt-auto border-t-2 border-black/10 pt-3" data-id="element-92" data-mp="3kdmxw5la2ew8">
              <p className="font-body font-black text-[#171717] text-[14px] uppercase" data-id="element-93" data-mp="3ffbotx2t48f2">{r.name}</p>
              <p className="font-body font-bold text-gray-600 text-[12px]" data-id="element-94" data-mp="3u47slhxtyz9v">{r.role}</p>
            </div>
          </div>)}
      </div>
      <div className="flex items-center justify-center gap-2 mt-2 text-gray-500 font-body font-bold text-[11px] md:text-[12px] uppercase relative z-10" data-id="element-95" data-mp="3pd7w2dsmij7w">
        <span className="animate-pulse" data-id="element-96" data-mp="71l46iwb7kan">←</span> Deslizá para ver más <span className="animate-pulse" data-id="element-97" data-mp="2x526sptgx0p">→</span>
      </div>
    </section>;
};
export function App() {
  const faqs = [{
    q: "¿Qué recibo exactamente?",
    a: "Recibís un archivo digital (PDF) con más de 100 actividades de matemáticas, además de los 5 bonos exclusivos detallados en la página."
  }, {
    q: "¿Es un producto físico?",
    a: "No, es un producto 100% digital. Lo recibís en tu correo electrónico listo para descargar e imprimir las veces que quieras."
  }, {
    q: "¿Para qué edades sirve?",
    a: "El material está diseñado para niños que cursan entre 1.º y 5.º grado de primaria (aprox. 6 a 11 años), con niveles de dificultad progresivos."
  }, {
    q: "¿Puedo imprimir las actividades?",
    a: "¡Sí! Está diseñado específicamente para ser impreso. Podés imprimir todo el libro o solo las hojas que necesites en el momento."
  }, {
    q: "¿Puedo utilizarlo más de una vez?",
    a: "Al ser un archivo digital, podés imprimir las actividades todas las veces que necesites para tu hijo o tus alumnos."
  }, {
    q: "¿Sirve para docentes?",
    a: "Absolutamente. Muchos docentes utilizan este material en el aula como una forma divertida de repasar conceptos o como actividades de extensión."
  }, {
    q: "¿Necesito tener Minecraft?",
    a: "No, no es necesario tener el juego ni saber jugarlo. Las actividades usan la estética y temática visual para hacerlas más atractivas, pero se resuelven en papel."
  }, {
    q: "¿Cómo recibo el material?",
    a: "Inmediatamente después de confirmar el pago, recibirás un correo electrónico con los enlaces para descargar todo el material."
  }];
  return <div className="min-h-screen bg-[#111] flex justify-center font-body" data-id="element-98" data-mp="iopiblglcsqs">
      <SalesPopup data-id="element-99" data-mp="dvwer0wuzqga" />
      {/* Main Container - Narrow centered sales page */}
      <div className="w-full max-w-[800px] bg-sky-blue relative shadow-[0_0_30px_rgba(0,0,0,0.8)] overflow-hidden" data-id="element-100" data-mp="8yme0p40rsd5">
        
        {/* 1. HERO */}
        <section className="w-full bg-minecraft-landscape relative pb-8 overflow-hidden" style={{
        paddingBottom: "0px"
      }} data-id="element-101" data-mp="3wx3dakplgpl">
          {/* Decorative Elements */}
          <GameDecoration type="pickaxe" className="w-[70px] md:w-[90px] -left-[20px] top-[38%] -rotate-[20deg]" data-id="element-102" data-mp="3r4ip38l4epun" />
          <GameDecoration type="diamond" className="w-[40px] md:w-[50px] right-[15px] top-[55%] animate-game-float" data-id="element-103" data-mp="3m6h60nnp2qj6" />
          <GameDecoration type="grass-block" className="w-[40px] md:w-[60px] right-[10%] bottom-[10%]" data-id="element-104" data-mp="1pa07y4vmhaka" />

          {/* Top Strip */}
          <div className="bg-dark-brown text-white font-body font-bold text-[11px] md:text-sm h-[38px] px-4 flex justify-between items-center border-b-4 border-[#111] relative z-10" data-id="element-105" data-mp="2c7vpj2h7ziba">
            <span data-id="element-106" data-mp="22h9gjr40dq1k">🎮 MATEMÁTICAS EN MODO JUEGO</span>
            <span className="text-[#FFC928]" data-id="element-107" data-mp="22fyepwu4isd3">OFERTA ESPECIAL</span>
          </div>

          <div className="px-4 pt-5 pb-2 text-center flex flex-col items-center relative z-10" data-id="element-108" data-mp="1xhohzhsr3jpd">
            {/* Small Badge */}
            <motion.div initial={{
            opacity: 0,
            y: -20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} className="inline-flex items-center justify-center bg-yellow-pixel text-[#111] font-body font-black text-[11px] md:text-sm px-3 h-[32px] pixel-border hard-shadow-sm mb-4 uppercase leading-none" data-id="element-109" data-mp="1tertxbkfyve1">
              🎮 +100 ACTIVIDADES · 1.º A 5.º DE PRIMARIA
            </motion.div>
            
            {/* Main Headline */}
            <motion.h1 initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="font-display text-[34px] md:text-6xl lg:text-7xl text-white text-outline leading-[1.05] tracking-tight mb-3 uppercase max-w-[95%] animate-mc-breathe" data-id="element-110" data-mp="3hevjdv3rxidy">
              ¿TU HIJO AMA MINECRAFT<br data-id="element-111" data-mp="2ygt2y4paktrr" />
              PERO NO LAS <span className="text-[#FFC928]" data-id="element-112" data-mp="2yhkladtvov03">MATEMÁTICAS</span>?
            </motion.h1>
            
            {/* Subheadline */}
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="font-body font-bold text-[#111] text-[16px] leading-[1.3] max-w-[340px] mx-auto mb-4" data-id="element-113" data-mp="37gfwk4bs4va9">
              Convertí la práctica en misiones y desafíos que realmente tenga ganas de completar.
            </motion.p>
            
            {/* Product Image - HUGE */}
            <motion.div initial={{
            opacity: 0,
            y: 40
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.3
          }} className="w-[112%] -ml-[6%] md:w-full md:ml-0 mt-2 mb-6" data-id="element-114" data-mp="3t7pkmtgcv50k">
              <img src={IMAGES.packCompleto} alt="Pack Completo" className="w-full md:w-[95%] mx-auto block drop-shadow-2xl animate-float" data-id="element-115" data-mp="3fg2em1wm2i4l" />
            </motion.div>
            
            {/* Dark Panel */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.4
          }} className="bg-dark-brown text-white font-body font-black text-[14px] md:text-lg h-[50px] flex items-center justify-center px-3 pixel-border hard-shadow w-full max-w-[95%] mb-5 uppercase tracking-wide" data-id="element-116" data-mp="3p5ly99s5eg0i">
              +100 ACTIVIDADES • 5 NIVELES • 5 BONOS GRATIS
            </motion.div>
            
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.5
          }} className="w-full max-w-[95%]" data-id="element-117" data-mp="1c07ctjyy2pqq">
              <CTAButton showTimer={false} showFeatures={true} href="#resumen-oferta" data-id="element-118" data-mp="1pz6to5g7u0cc" />
            </motion.div>
          </div>
        </section>

        {/* Pixel Divider */}
        <div className="w-full flex flex-col relative z-10" data-id="element-119" data-mp="1uvnspuoydz47">
          <div className="h-6 bg-grass-green border-y-4 border-[#111]" data-id="element-120" data-mp="1gxh3f2y2l7g5"></div>
          <div className="h-6 bg-medium-brown border-b-4 border-[#111]" data-id="element-121" data-mp="1kz2nb890ulzu"></div>
        </div>

        {/* 2. PROBLEMA */}
        <section className="bg-off-white px-4 py-12 relative overflow-hidden" data-id="element-122" data-mp="5iak3t9t5oxa">
          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-display text-[30px] md:text-[40px] text-[#111] text-center mb-6 uppercase leading-tight relative z-10" data-id="element-123" data-mp="9kxeo1xv5ny6">
            ¿TU HIJO AMA LOS JUEGOS...<br data-id="element-124" data-mp="b373h939cz5i" />
            <span className="text-[#E53E3E]" data-id="element-125" data-mp="b3p2uel7vthn">PERO LAS MATEMÁTICAS LE PARECEN ABURRIDAS?</span>
          </motion.h2>
          
          <motion.p initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="font-body font-bold text-lg text-center mb-8 text-[#302A26] relative z-10" data-id="element-126" data-mp="18q5w98qtxmy4">
            Sentarlo a practicar no debería convertirse todos los días en una negociación.
          </motion.p>
          
          <div className="flex flex-col gap-4 mb-10 max-w-[90%] mx-auto relative z-10" data-id="element-127" data-mp="3fgvv12i36269">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="bg-white pixel-border hard-shadow p-4 flex items-center gap-4" data-id="element-128" data-mp="1uzmohit996oe">
              <span className="text-3xl" data-id="element-129" data-mp="28skr9q81211z">😩</span>
              <p className="font-body font-bold text-[#171717] text-lg" data-id="element-130" data-mp="2dqdty9a4gcxi">Se aburre rápidamente</p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.3
          }} className="bg-white pixel-border hard-shadow p-4 flex items-center gap-4" data-id="element-131" data-mp="2incr70p30zzx">
              <span className="text-3xl" data-id="element-132" data-mp="xat2lhk9dkgm">🧠</span>
              <p className="font-body font-bold text-[#171717] text-lg" data-id="element-133" data-mp="xbl0iz1bvua2">Pierde la concentración</p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.4
          }} className="bg-white pixel-border hard-shadow p-4 flex items-center gap-4" data-id="element-134" data-mp="20o34sjdt571k">
              <span className="text-3xl" data-id="element-135" data-mp="2jjt7k8tke7gi">📚</span>
              <p className="font-body font-bold text-[#171717] text-lg" data-id="element-136" data-mp="2em1az1hz5x5z">Los ejercicios tradicionales no logran engancharlo</p>
            </motion.div>
          </div>
          
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.5
        }} className="bg-yellow-pixel pixel-border hard-shadow p-6 text-center max-w-[95%] mx-auto relative z-10" data-id="element-137" data-mp="2sfioo5nzcfo3">
            <h3 className="font-body font-black text-xl mb-2 text-[#171717]" data-id="element-138" data-mp="3gyu90wak5jwi">¿Y si en lugar de luchar contra lo que le gusta... lo usamos a nuestro favor?</h3>
            <p className="font-body font-black text-[24px] md:text-[28px] text-[#171717] uppercase mt-4" data-id="element-139" data-mp="370msufo3f5vk">
              TRANSFORMÁ LA PRÁCTICA EN UNA MISIÓN.
            </p>
          </motion.div>
        </section>

        {/* Pixel Divider */}
        <div className="w-full flex flex-col relative z-10" data-id="element-140" data-mp="2y68jetq8upkd">
          <div className="h-6 bg-medium-brown border-y-4 border-[#111]" data-id="element-141" data-mp="32yrtvhtmx4ky"></div>
          <div className="h-6 bg-grass-green border-b-4 border-[#111]" data-id="element-142" data-mp="2o9n85qnmsi83"></div>
        </div>

        {/* 3. PRESENTACIÓN DEL PRODUCTO */}
        <section className="bg-sky-blue px-4 py-12 text-center relative overflow-hidden" data-id="element-143" data-mp="2t9rsjrrntx3l">
          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-body font-black text-[28px] md:text-[34px] text-[#171717] uppercase mb-4 leading-tight relative z-10" data-id="element-144" data-mp="2f8p7niceisu9">
            CONOCÉ +100 ACTIVIDADES DE MATEMÁTICAS
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="font-body font-bold text-[#171717] text-lg bg-white/80 px-4 py-2 pixel-border inline-block mb-10 max-w-[95%] relative z-10" data-id="element-145" data-mp="2pqavxvcao6w1">
            Una forma diferente de practicar matemática aprovechando un universo que los chicos ya conocen y disfrutan.
          </motion.p>
          
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="w-[85%] max-w-[400px] mx-auto mb-10 relative z-10" data-id="element-146" data-mp="1x2ygs68gr1cr">
            <img src={IMAGES.mainBook} alt="Libro Principal" className="w-full block drop-shadow-2xl animate-float" data-id="element-147" data-mp="ck4cyp5xo8tc" />
          </motion.div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10 text-left max-w-[95%] mx-auto relative z-10" data-id="element-148" data-mp="mjbsnj054fjm">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.3
          }} className="bg-off-white pixel-border hard-shadow p-4" data-id="element-149" data-mp="3l18x93tpms1i">
              <h4 className="font-body font-black text-[19px] tracking-tight text-[#171717] mb-1 uppercase" data-id="element-150" data-mp="3m28fzmzqy1b">🎮 APRENDER JUGANDO</h4>
              <p className="font-body font-medium text-[15px] leading-[1.4] text-[#302A26]" data-id="element-151" data-mp="328n812db5zpw">Actividades presentadas como desafíos.</p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.4
          }} className="bg-off-white pixel-border hard-shadow p-4" data-id="element-152" data-mp="2h0ymionrwy25">
              <h4 className="font-body font-black text-[19px] tracking-tight text-[#171717] mb-1 uppercase" data-id="element-153" data-mp="2c2exughsp863">🧠 PRACTICAR</h4>
              <p className="font-body font-medium text-[15px] leading-[1.4] text-[#302A26]" data-id="element-154" data-mp="22zm8wjw358jf">Conceptos fundamentales de matemática.</p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.5
          }} className="bg-off-white pixel-border hard-shadow p-4" data-id="element-155" data-mp="1ocsx3olrykvz">
              <h4 className="font-body font-black text-[19px] tracking-tight text-[#171717] mb-1 uppercase" data-id="element-156" data-mp="10ncr81di824t">🏆 AVANZAR</h4>
              <p className="font-body font-medium text-[15px] leading-[1.4] text-[#302A26]" data-id="element-157" data-mp="vpjk964dn43h">Cada actividad se convierte en un nuevo logro.</p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.6
          }} className="bg-off-white pixel-border hard-shadow p-4" data-id="element-158" data-mp="15mxn22xdnudb">
              <h4 className="font-body font-black text-[19px] tracking-tight text-[#171717] mb-1 uppercase" data-id="element-159" data-mp="1tayqixfp8klv">🖨️ IMPRIMIR Y USAR</h4>
              <p className="font-body font-medium text-[15px] leading-[1.4] text-[#302A26]" data-id="element-160" data-mp="1of9xze23k3z2">Elegí las actividades que necesites.</p>
            </motion.div>
          </div>
          
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.7
        }} className="max-w-[90%] mx-auto relative z-10" data-id="element-161" data-mp="1xfgaawm26xwn">
            <CTAButton showTimer={false} data-id="element-162" data-mp="13zudrfrnm38n" />
          </motion.div>
        </section>

        {/* Pixel Divider */}
        <div className="w-full h-4 bg-[#111] relative z-10" data-id="element-163" data-mp="18totk8451y2g"></div>

        {/* 4. MOSTRAR LAS ACTIVIDADES */}
        <section className="bg-[#1A365D] px-4 py-12 text-center border-b-4 border-[#111] relative overflow-hidden" data-id="element-164" data-mp="1iq1lb0g4i1uk">
          {/* Decorative Elements */}
          <GameDecoration type="pig" className="w-[60px] md:w-[80px] top-[20%] right-[5%] md:right-[15%] rotate-12" data-id="element-165" data-mp="1nqfuiltgnhu6" />
          <GameDecoration type="diamond" className="w-[40px] md:w-[50px] bottom-[20%] left-[5%] md:left-[15%] animate-game-float" data-id="element-166" data-mp="1rpwzzf8w0ezc" />

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-body font-black text-[22px] md:text-2xl text-yellow-pixel mb-2 uppercase animate-mc-breathe relative z-10" data-id="element-167" data-mp="3thtcar2vpsv6">NO ES SOLO UN LIBRO...</motion.h2>
          <motion.h3 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="font-body font-black text-[28px] md:text-[34px] text-white uppercase mb-10 leading-tight relative z-10" data-id="element-168" data-mp="3875l2uc7bz0n">
            SON +100 ACTIVIDADES PARA RESOLVER, PRACTICAR Y SUPERAR
          </motion.h3>
          
          <motion.img initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} src={IMAGES.packCompleto} alt="Hojas de actividades" className="w-[95%] mx-auto block drop-shadow-2xl mb-10 relative z-10" data-id="element-169" data-mp="3qzrbgz4caxdu" />
          
          <div className="flex flex-wrap justify-center gap-2 max-w-[95%] mx-auto relative z-10" data-id="element-170" data-mp="c2l5e4vo2qna">
            {['NÚMEROS Y CONTEO', 'SUMAS Y RESTAS', 'MULTIPLICACIONES', 'DIVISIONES', 'TABLAS', 'FRACCIONES', 'GEOMETRÍA', 'MEDIDAS', 'DINERO', 'GRÁFICOS', 'PORCENTAJES', 'PROBLEMAS'].map((tag, i) => <motion.span initial={{
            opacity: 0,
            scale: 0.8
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: 0.3 + i * 0.05
          }} key={i} className="bg-off-white pixel-border hard-shadow px-3 py-1 font-body font-extrabold text-[#171717] text-[14px] md:text-base uppercase" data-id="element-171" data-mp="q12plsmd5l0g" data-mpi={i}>
                {tag}
              </motion.span>)}
          </div>
        </section>

        {/* CAROUSEL DE MUESTRAS */}
        <AutoScrollCarousel data-id="element-172" data-mp="2y6v3npmf6p9c" />

        {/* 5. LOS 5 NIVELES */}
        <section className="bg-off-white px-4 py-12 relative overflow-hidden" data-id="element-173" data-mp="2u6l0sltxceyp">
          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-body font-black text-[28px] md:text-[34px] text-[#171717] text-center mb-10 uppercase leading-tight relative z-10" data-id="element-174" data-mp="2u8no2y3oztzq">
            UN MATERIAL QUE LO ACOMPAÑA DE 1.º A 5.º DE PRIMARIA
          </motion.h2>
          
          <div className="flex flex-col gap-4 max-w-[95%] mx-auto relative z-10" data-id="element-175" data-mp="2p8szj17e3ghu">
            {[{
            level: 1,
            grade: "1.º DE PRIMARIA",
            color: "bg-[#55A83C]",
            topics: "Números y conteo • Sumas y restas • Geometría • Medidas • Dinero",
            iconType: "grass-block"
          }, {
            level: 2,
            grade: "2.º DE PRIMARIA",
            color: "bg-[#ED8936]",
            topics: "Valor posicional • Multiplicación • División • Secuencias • Geometría y medidas",
            iconType: "gold"
          }, {
            level: 3,
            grade: "3.º DE PRIMARIA",
            color: "bg-[#4299E1]",
            topics: "Multiplicaciones • Divisiones • Fracciones • Tablas • Perímetro • Problemas",
            iconType: "diamond"
          }, {
            level: 4,
            grade: "4.º DE PRIMARIA",
            color: "bg-[#9F7AEA]",
            topics: "Operaciones • Múltiplos y divisores • Fracciones y decimales • Área • Gráficos",
            iconType: "emerald"
          }, {
            level: 5,
            grade: "5.º DE PRIMARIA",
            color: "bg-[#F56565]",
            topics: "Porcentajes • Proporciones • Volumen • Geometría • Probabilidad",
            iconType: "trophy"
          }].map((lvl, i) => <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.15
          }} key={i} className="bg-white pixel-border hard-shadow flex flex-col sm:flex-row relative overflow-hidden z-10" data-id="element-176" data-mp="123gnsqtwy9vq" data-mpi={i}>
                <div className="absolute -right-4 -bottom-4 opacity-20 drop-shadow-none pointer-events-none w-24 h-24" data-id="element-177" data-mp="ygih53ea17nq">
                  <GameDecoration type={lvl.iconType} className="w-full h-full" data-id="element-178" data-mp="tg4a9ooew3ra" />
                </div>
                <div className={`${lvl.color} p-4 border-b-4 sm:border-b-0 sm:border-r-4 border-[#111] flex flex-col justify-center items-center sm:w-1/3 relative z-10`} data-id="element-179" data-mp="ol76aw5zokl9">
                  <span className="font-body font-black text-white text-[20px] uppercase flex items-center gap-2" data-id="element-180" data-mp="fjr2565rpeph">
                    <GameDecoration type={lvl.iconType} className="w-6 h-6 relative" data-id="element-181" data-mp="2dx98eq0b18xd" /> NIVEL {lvl.level}
                  </span>
                  <span className="font-body font-bold text-white text-[16px] text-center mt-1 uppercase leading-tight" data-id="element-182" data-mp="2t5719wwa0921">{lvl.grade}</span>
                </div>
                <div className="p-4 sm:w-2/3 flex items-center" data-id="element-183" data-mp="2x6aj2oxvwf5w">
                  <p className="font-body font-bold text-[#171717] text-[15px] leading-[1.4]" data-id="element-184" data-mp="2jg72oelorfod">{lvl.topics}</p>
                </div>
              </motion.div>)}
          </div>
        </section>

        {/* Pixel Divider */}
        <div className="w-full flex flex-col relative z-10" data-id="element-185" data-mp="29gg6m8hh8sm6">
          <div className="h-6 bg-grass-green border-y-4 border-[#111]" data-id="element-186" data-mp="2eg2lsngv8ixm"></div>
        </div>

        {/* 6. BENEFICIO EMOCIONAL */}
        <section className="bg-sky-blue px-4 py-12 text-center relative overflow-hidden" data-id="element-187" data-mp="20hkzmu6lzeht">
          {/* Decorative Elements */}
          <GameDecoration type="torch" className="w-[30px] md:w-[50px] left-0 top-[40%] animate-torch-flicker" data-id="element-188" data-mp="25fw9h4wwlp01" />
          <GameDecoration type="torch" className="w-[30px] md:w-[50px] right-0 top-[40%] animate-torch-flicker" data-id="element-189" data-mp="3uspyzmanx4rc" />

          <div className="bg-off-white pixel-border hard-shadow p-6 md:p-8 max-w-[95%] mx-auto relative z-10" data-id="element-190" data-mp="ds7qe2ugv8jm">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} className="font-body font-extrabold text-[21px] leading-[1.15] tracking-[-0.3px] text-[#171717] mb-4 uppercase" data-id="element-191" data-mp="8tmziu13u17u">
              MENOS "NO QUIERO<br data-id="element-192" data-mp="rjuxyytv03hp" />HACER MATEMÁTICA"...
            </motion.h2>
            <motion.h3 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="font-body font-black text-[27px] leading-[1.05] tracking-[-0.5px] text-[#171717] mb-6 uppercase" data-id="element-193" data-mp="rjcubh4vamzr">
              Y MÁS...<br data-id="element-194" data-mp="33ayjqmrgsrvd" />"¿CUÁL ES LA<br data-id="element-195" data-mp="33bi56dgbpye5" /><span className="text-[#F6B900]" data-id="element-196" data-mp="1ii6kpaoxt8uj">PRÓXIMA MISIÓN?</span>" 🎮
            </motion.h3>
            
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="font-body font-bold text-[#302A26] text-[16px] md:text-[18px] leading-[1.45] mb-8" data-id="element-197" data-mp="1djd5ndu059s9">
              No buscamos reemplazar la enseñanza escolar. Buscamos darle una forma diferente de practicar lo que necesita aprender.
            </motion.p>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-left" data-id="element-198" data-mp="2b5kc6t9v9c79">
              {['Más interés', 'Más práctica', 'Más autonomía', 'Menos resistencia'].map((item, i) => <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: 0.3 + i * 0.1
            }} key={i} className="group flex items-center gap-3 bg-white pixel-border p-3 transition-all duration-200 hover:-translate-y-1 hover:shadow-[4px_4px_0px_0px_#111] cursor-default" data-id="element-199" data-mp="2k70m6zwrrcay" data-mpi={i}>
                  <div className="bg-grass-green w-8 h-8 flex items-center justify-center flex-shrink-0 border-2 border-[#111] group-hover:bg-yellow-pixel transition-colors duration-200" data-id="element-200" data-mp="2tuebycp2nk99">
                    <span className="text-white font-bold text-xl leading-none animate-level-up" style={{
                  animationDelay: `${i * 0.2}s`
                }} data-id="element-201" data-mp="2kuzlvecthbpa">✓</span>
                  </div>
                  <span className="font-body font-bold text-[16px] text-[#171717] group-hover:text-grass-green transition-colors duration-200" data-id="element-202" data-mp="2b44vbxsjfpy1">{item}</span>
                </motion.div>)}
            </div>
          </div>
        </section>

        {/* Pixel Divider */}
        <div className="w-full h-4 bg-[#111] relative z-10" data-id="element-203" data-mp="225t01igq83z9"></div>

        {/* 7. LOS 5 BONOS */}
        <section className="bg-[#9F7AEA] px-4 py-12 text-center border-b-4 border-[#111] relative overflow-hidden" data-id="element-204" data-mp="7pm834prnv2m">
          {/* Decorative Elements */}
          <GameDecoration type="chest" className="w-[60px] md:w-[80px] top-[10%] right-[10%]" data-id="element-205" data-mp="3u4dvujbnnxfj" />
          <GameDecoration type="diamond" className="w-[30px] md:w-[40px] top-[30%] left-[5%] animate-game-float" data-id="element-206" data-mp="3q2sd4hcfwoxf" />
          <GameDecoration type="diamond" className="w-[25px] md:w-[35px] bottom-[40%] right-[5%] animate-game-float" style={{
          animationDelay: '1s'
        }} data-id="element-207" data-mp="qm3ur7prd4s0" />
          <GameDecoration type="diamond" className="w-[35px] md:w-[45px] bottom-[10%] left-[10%] animate-game-float" style={{
          animationDelay: '2s'
        }} data-id="element-208" data-mp="hl621lkrsjoq" />

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-body font-black text-[18px] text-yellow-pixel mb-2 uppercase animate-mc-breathe relative z-10" data-id="element-209" data-mp="32c6jvw73h97h">PERO ESO NO ES TODO...</motion.p>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="font-display text-4xl md:text-5xl text-white text-outline uppercase mb-12 leading-tight animate-mc-breathe relative z-10" data-id="element-210" data-mp="1hs1emlyldl04">
            🎁 TE LLEVÁS 5 BONOS GRATIS
          </motion.h2>
          
          <div className="flex flex-col gap-12 max-w-[90%] mx-auto relative z-10" data-id="element-211" data-mp="25l1fsgjpu7f1">
            {/* Bono 1 */}
            <motion.div initial={{
            opacity: 0,
            y: 40
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="bg-white pixel-border hard-shadow p-6 relative" data-id="element-212" data-mp="29ks2a827m1dr">
              <div className="absolute bottom-4 right-4 text-3xl drop-shadow-[2px_2px_0px_rgba(17,17,17,1)] opacity-70" data-id="element-213" data-mp="3c16lofg9p2j1">🏆</div>
              <div className="absolute -top-4 -right-2 bg-yellow-pixel text-[#111] font-display text-xl pixel-border px-3 py-1 transform rotate-3 uppercase animate-gift-pop" data-id="element-214" data-mp="3q0xrvu0jlemh">GRATIS</div>
              <img src={IMAGES.bonus1} alt="Tarjetas de Recompensa" className="w-[80%] max-w-[250px] h-[250px] object-contain mx-auto mb-6 drop-shadow-xl animate-gift-pop" style={{
              animationDelay: '0.5s'
            }} data-id="element-215" data-mp="2xbh6hgbcaxzr" />
              <h3 className="font-body font-black text-[18px] text-[#9F7AEA] mb-1 uppercase" data-id="element-216" data-mp="373ej8rhzxy0l">BONO #1</h3>
              <h4 className="font-body font-black text-[22px] md:text-[26px] text-[#171717] mb-2 uppercase leading-tight" data-id="element-217" data-mp="329ikvnxtm94w">TARJETAS DE RECOMPENSA</h4>
              <p className="font-body font-bold text-[#E53E3E] mb-3 uppercase text-[15px]" data-id="element-218" data-mp="29mpmvdbtfnyl">¡DESBLOQUEÁ SUS LOGROS!</p>
              <p className="font-body font-medium text-[#302A26] text-[15px] leading-[1.45] md:text-base" data-id="element-219" data-mp="p4573earssi8">Reconocé cada actividad completada y ayudalo a mantener sus ganas de continuar.</p>
            </motion.div>

            {/* Bono 2 */}
            <motion.div initial={{
            opacity: 0,
            y: 40
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.3
          }} className="bg-white pixel-border hard-shadow p-6 relative" data-id="element-220" data-mp="g5jrns0lhtlo">
              <div className="absolute bottom-4 right-4 text-3xl drop-shadow-[2px_2px_0px_rgba(17,17,17,1)] opacity-70" data-id="element-221" data-mp="yuq79663e539">🧭</div>
              <div className="absolute -top-4 -left-2 bg-yellow-pixel text-[#111] font-display text-xl pixel-border px-3 py-1 transform -rotate-3 uppercase animate-gift-pop" style={{
              animationDelay: '0.2s'
            }} data-id="element-222" data-mp="13rynv2ble12e">GRATIS</div>
              <img src={IMAGES.bonus2} alt="Mapa de Progreso" className="w-[80%] max-w-[250px] h-[250px] object-contain mx-auto mb-6 drop-shadow-xl animate-gift-pop" style={{
              animationDelay: '0.7s'
            }} data-id="element-223" data-mp="1u3ajcmfie893" />
              <h3 className="font-body font-black text-[18px] text-[#9F7AEA] mb-1 uppercase" data-id="element-224" data-mp="1kcpcyctlfzfm">BONO #2</h3>
              <h4 className="font-body font-black text-[22px] md:text-[26px] text-[#171717] mb-2 uppercase leading-tight" data-id="element-225" data-mp="1gcovskf41a4v">MAPA DE PROGRESO</h4>
              <p className="font-body font-bold text-[#E53E3E] mb-3 uppercase text-[15px]" data-id="element-226" data-mp="1bapt7cr72h8z">¡QUE VEA TODO LO QUE AVANZÓ!</p>
              <p className="font-body font-medium text-[#302A26] text-[15px] leading-[1.45] md:text-base" data-id="element-227" data-mp="11emvqk7af6sd">Convertí cada actividad completada en un paso visible hacia su próxima meta.</p>
            </motion.div>

            {/* Bono 3 */}
            <motion.div initial={{
            opacity: 0,
            y: 40
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.4
          }} className="bg-white pixel-border hard-shadow p-6 relative" data-id="element-228" data-mp="2vrmgerqiyr6i">
              <div className="absolute -top-4 -right-2 bg-yellow-pixel text-[#111] font-display text-xl pixel-border px-3 py-1 transform rotate-3 uppercase animate-gift-pop" style={{
              animationDelay: '0.4s'
            }} data-id="element-229" data-mp="ig1h8l8fn9yh">GRATIS</div>
              <img src={IMAGES.bonus3} alt="Guía para Padres" className="w-[80%] max-w-[250px] h-[250px] object-contain mx-auto mb-6 drop-shadow-xl animate-gift-pop" style={{
              animationDelay: '0.9s'
            }} data-id="element-230" data-mp="3qql2sxcoeagw" />
              <h3 className="font-body font-black text-[18px] text-[#9F7AEA] mb-1 uppercase" data-id="element-231" data-mp="3jk9s53d6fh7">BONO #3</h3>
              <h4 className="font-body font-black text-[22px] md:text-[26px] text-[#171717] mb-2 uppercase leading-tight" data-id="element-232" data-mp="8lhz9h2cy6il">GUÍA PARA PADRES Y DOCENTES</h4>
              <p className="font-body font-medium text-[#302A26] text-[15px] leading-[1.45] md:text-base mt-4" data-id="element-233" data-mp="1jykdw6kwcm04">Ideas prácticas para acompañar, motivar y aprovechar mejor cada actividad, tanto en casa como en el aula.</p>
            </motion.div>

            {/* Bono 4 */}
            <motion.div initial={{
            opacity: 0,
            y: 40
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.5
          }} className="bg-white pixel-border hard-shadow p-6 relative" data-id="element-234" data-mp="14f3hz3shxjgg">
              <div className="absolute bottom-4 right-4 text-3xl drop-shadow-[2px_2px_0px_rgba(17,17,17,1)] opacity-70" data-id="element-235" data-mp="19d54xzt1m2x7">🧩</div>
              <div className="absolute -top-4 -left-2 bg-yellow-pixel text-[#111] font-display text-xl pixel-border px-3 py-1 transform -rotate-3 uppercase animate-gift-pop" style={{
              animationDelay: '0.6s'
            }} data-id="element-236" data-mp="1nd6b9us2u2k2">GRATIS</div>
              <img src={IMAGES.bonus4} alt="Problemas Matemáticos" className="w-[80%] max-w-[250px] h-[250px] object-contain mx-auto mb-6 drop-shadow-xl animate-gift-pop" style={{
              animationDelay: '1.1s'
            }} data-id="element-237" data-mp="3l48y48sz9tkw" />
              <h3 className="font-body font-black text-[18px] text-[#9F7AEA] mb-1 uppercase" data-id="element-238" data-mp="3f0w0u9oxkmm0">BONO #4</h3>
              <h4 className="font-body font-black text-[22px] md:text-[26px] text-[#171717] mb-2 uppercase leading-tight" data-id="element-239" data-mp="319hfvxbgqbcb">PROBLEMAS MATEMÁTICOS</h4>
              <p className="font-body font-bold text-[#E53E3E] mb-3 uppercase text-[15px]" data-id="element-240" data-mp="2rc30m119zsll">¡DESAFÍOS PARA PENSAR!</p>
              <p className="font-body font-medium text-[#302A26] text-[15px] leading-[1.45] md:text-base" data-id="element-241" data-mp="2wb66fnp2y2um">Situaciones para pensar, resolver y superar, llevando la lógica matemática un paso más allá.</p>
            </motion.div>

            {/* Bono 5 */}
            <motion.div initial={{
            opacity: 0,
            y: 40
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.6
          }} className="bg-white pixel-border hard-shadow p-6 relative" data-id="element-242" data-mp="2ncc5xm8mosbs">
              <div className="absolute bottom-4 right-4 text-3xl drop-shadow-[2px_2px_0px_rgba(17,17,17,1)] opacity-70" data-id="element-243" data-mp="1s8surtggcvbr">✖️</div>
              <div className="absolute -top-4 -right-2 bg-yellow-pixel text-[#111] font-display text-xl pixel-border px-3 py-1 transform rotate-3 uppercase animate-gift-pop" style={{
              animationDelay: '0.8s'
            }} data-id="element-244" data-mp="1x744832u53tg">GRATIS</div>
              <img src={IMAGES.bonus5} alt="Tabla de Multiplicar" className="w-[80%] max-w-[250px] h-[250px] object-contain mx-auto mb-6 drop-shadow-xl animate-gift-pop" style={{
              animationDelay: '1.3s'
            }} data-id="element-245" data-mp="2aztoo32pu0og" />
              <h3 className="font-body font-black text-[18px] text-[#9F7AEA] mb-1 uppercase" data-id="element-246" data-mp="2kx86o74aexiv">BONO #5</h3>
              <h4 className="font-body font-black text-[22px] md:text-[26px] text-[#171717] mb-2 uppercase leading-tight" data-id="element-247" data-mp="lmgsj14rbiyf">TABLA DE MULTIPLICAR</h4>
              <p className="font-body font-bold text-[#E53E3E] mb-3 uppercase text-[15px]" data-id="element-248" data-mp="33ui2l051fi1l">¡APRENDÉ Y DOMINÁ!</p>
              <p className="font-body font-medium text-[#302A26] text-[15px] leading-[1.45] md:text-base" data-id="element-249" data-mp="2z41nzcphdqdn">Practicá las tablas paso a paso hasta memorizarlas y dominarlas por completo.</p>
            </motion.div>
          </div>
          
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.7
        }} className="mt-12 bg-yellow-pixel pixel-border hard-shadow p-4 inline-block max-w-[95%] relative z-10" data-id="element-250" data-mp="2q4elsooxggjj">
            <p className="font-body font-black text-[18px] md:text-[22px] text-[#171717] uppercase leading-tight" data-id="element-251" data-mp="38u4glbsox2bg">LOS 5 BONOS ESTÁN INCLUIDOS SIN COSTO EXTRA</p>
          </motion.div>
        </section>

        {/* 8. TODO LO QUE RECIBÍS */}
        <section id="resumen-oferta" className="bg-off-white px-4 py-12 relative overflow-hidden" data-id="element-252" data-mp="1xcv08y4uyqed">
          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-body font-black text-[28px] md:text-[34px] text-[#171717] text-center mb-10 uppercase leading-tight relative z-10" data-id="element-253" data-mp="1yw4s5kkhow9g">
            MIRÁ TODO LO QUE TE LLEVÁS HOY
          </motion.h2>
          
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white pixel-border hard-shadow p-6 max-w-[95%] mx-auto relative z-10" data-id="element-254" data-mp="1kvk70hr3qocs">
            <img src={IMAGES.packCompleto} alt="Todo lo que recibís" className="w-[95%] mx-auto mb-8 drop-shadow-xl" data-id="element-255" data-mp="x6rih6ct7is7" />
            
            <ul className="space-y-4 font-body font-bold text-[#171717] text-[16px] md:text-[18px] mb-10" data-id="element-256" data-mp="1276rxmtz064w">
              <li className="flex items-center gap-3" data-id="element-257" data-mp="dkh9w19obgvd"><span className="text-2xl" data-id="element-258" data-mp="dliy77fp9zv1">📘</span> +100 Actividades de Matemáticas</li>
              <li className="flex items-center gap-3" data-id="element-259" data-mp="si07zu88r6fh"><span className="text-2xl" data-id="element-260" data-mp="sj1ju0x2zwy9">📚</span> Contenido de 1.º a 5.º de primaria</li>
              <li className="flex items-center gap-3" data-id="element-261" data-mp="nh2fanplutzq"><span className="text-2xl" data-id="element-262" data-mp="11ievn08ogxm5">🏆</span> Tarjetas de Recompensa (GRATIS)</li>
              <li className="flex items-center gap-3" data-id="element-263" data-mp="11g235t5an4uu"><span className="text-2xl" data-id="element-264" data-mp="wk3l0nak6j2v">🗺️</span> Mapa de Progreso (GRATIS)</li>
              <li className="flex items-center gap-3" data-id="element-265" data-mp="1b7yfo984mxil"><span className="text-2xl" data-id="element-266" data-mp="1b6wrd323oeix">👨‍👩‍👧‍👦</span> Guía para Padres y Docentes (GRATIS)</li>
              <li className="flex items-center gap-3" data-id="element-267" data-mp="16ag0w27fho2o"><span className="text-2xl" data-id="element-268" data-mp="16bhfuhrkeupo">🧩</span> Problemas Matemáticos (GRATIS)</li>
              <li className="flex items-center gap-3" data-id="element-269" data-mp="1k6tlhk79e5ld"><span className="text-2xl" data-id="element-270" data-mp="1g7uii5538iwk">✖️</span> Tabla de Multiplicar (GRATIS)</li>
              <li className="flex items-center gap-3" data-id="element-271" data-mp="39q1mtpdrkpok"><span className="text-2xl" data-id="element-272" data-mp="39p04r0ybz2xc">📄</span> Material digital</li>
              <li className="flex items-center gap-3" data-id="element-273" data-mp="3eol6tk8srrea"><span className="text-2xl" data-id="element-274" data-mp="3enjuzdjyj0vi">🖨️</span> Listo para imprimir</li>
              <li className="flex items-center gap-3" data-id="element-275" data-mp="3jfl6gx9awnkh"><span className="text-2xl" data-id="element-276" data-mp="3jgmojloqiabp">⚡</span> Acceso inmediato</li>
            </ul>
            
            <div className="bg-dark-brown pixel-border p-4 md:p-6 text-center text-white relative mt-6" data-id="element-277" data-mp="3oe4ud37gg9fh">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-yellow-pixel text-[#111] font-body font-black text-[12px] md:text-[14px] pixel-border px-3 py-1 uppercase whitespace-nowrap" data-id="element-278" data-mp="2qta6notiqqoq">
                TODO EL MATERIAL + LOS 5 BONOS
              </div>
              
              <div className="flex flex-col md:flex-row items-center justify-center gap-2 md:gap-6 mt-3 mb-4" data-id="element-279" data-mp="34oubjgcex8d5">
                <div className="flex flex-col items-center" data-id="element-280" data-mp="g1gynrepzdoc">
                  <p className="font-body font-bold text-gray-400 text-[16px] line-through mb-0" data-id="element-281" data-mp="jzen2s0o1vqo">Valor: $35.980</p>
                  <div className="bg-[#E53E3E] text-white font-body font-black px-2 py-0.5 pixel-border text-[14px] uppercase mt-1" data-id="element-282" data-mp="24hyykeuoi518">AHORRÁS 50%</div>
                </div>
                <p className="font-display text-4xl md:text-5xl text-yellow-pixel text-outline-sm uppercase leading-none" data-id="element-283" data-mp="1vpewt5j3bkc6">
                  <span className="text-[20px] block md:inline md:mr-2 text-white text-outline-none" data-id="element-284" data-mp="1qqu4dsa2y4ya">HOY</span>
                  $17.990 ARS
                </p>
              </div>
              
              <CTAButton data-id="element-285" data-mp="1grmjmk10n815" />
            </div>
          </motion.div>
        </section>

        {/* Pixel Divider */}
        <div className="w-full flex flex-col relative z-10" data-id="element-286" data-mp="1crufqkmkhq24">
          <div className="h-6 bg-medium-brown border-y-4 border-[#111]" data-id="element-287" data-mp="17tj9ejvhdxon"></div>
          <div className="h-6 bg-grass-green border-b-4 border-[#111]" data-id="element-288" data-mp="37658332df2cn"></div>
        </div>

        {/* 9. CÓMO FUNCIONA */}
        <section className="bg-sky-blue px-4 py-12 text-center relative overflow-hidden" data-id="element-289" data-mp="327k8n5uy0mp9">
          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-body font-black text-[28px] md:text-[34px] text-[#171717] uppercase mb-10 leading-tight relative z-10" data-id="element-290" data-mp="3lavouuoscjog">
            EMPEZAR ES MUY FÁCIL
          </motion.h2>
          
          <div className="flex flex-col gap-6 max-w-[95%] mx-auto relative z-10" data-id="element-291" data-mp="8u8n5u8ec7i7">
            {[{
            step: "1",
            title: "COMPRÁS",
            desc: "Realizás tu compra de forma segura."
          }, {
            step: "2",
            title: "RECIBÍS EL MATERIAL",
            desc: "Accedés al contenido digital al instante."
          }, {
            step: "3",
            title: "IMPRIMÍS Y EMPIEZAN LAS MISIONES",
            desc: "Elegí las actividades y comenzá a utilizarlas."
          }].map((item, i) => <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.2
          }} key={i} className="bg-off-white pixel-border hard-shadow p-4 flex items-center gap-4 text-left" data-id="element-292" data-mp="2oiiem8jg9apc" data-mpi={i}>
                <div className="bg-yellow-pixel pixel-border w-14 h-14 flex-shrink-0 flex items-center justify-center font-body font-black text-[24px] text-[#171717]" data-id="element-293" data-mp="2l0upilpt4ski">
                  {item.step}
                </div>
                <div data-id="element-294" data-mp="27363vbnx1hee">
                  <h3 className="font-body font-black text-[18px] md:text-[20px] text-[#171717] uppercase mb-1" data-id="element-295" data-mp="273poj04yajw4">{item.title}</h3>
                  <p className="font-body font-medium text-[15px] leading-[1.45] text-[#302A26]" data-id="element-296" data-mp="22bo42qxmpmv0">{item.desc}</p>
                </div>
              </motion.div>)}
          </div>
        </section>

        {/* Pixel Divider */}
        <div className="w-full flex flex-col relative z-10" data-id="element-297" data-mp="19niki7iba3wr">
          <div className="h-6 bg-grass-green border-y-4 border-[#111]" data-id="element-298" data-mp="p30af2i9c29j"></div>
          <div className="h-6 bg-medium-brown border-b-4 border-[#111]" data-id="element-299" data-mp="t3aickpm12r1"></div>
        </div>

        {/* 10. TESTIMONIOS */}
        <Testimonials data-id="element-300" data-mp="y1ln4h11sn2e" />

        {/* Pixel Divider */}
        <div className="w-full h-4 bg-[#111] relative z-10" data-id="element-301" data-mp="131q74h15zzxd"></div>

        {/* 11. PARA QUIÉN ES */}
        <section className="bg-medium-brown px-4 py-12 relative overflow-hidden" data-id="element-302" data-mp="180t218nfkprm">
          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-body font-black text-[28px] md:text-[34px] text-white text-center mb-10 uppercase relative z-10" data-id="element-303" data-mp="17yqcsqu3r0ny">
            IDEAL PARA...
          </motion.h2>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-[95%] mx-auto relative z-10" data-id="element-304" data-mp="1qphj1jismay4">
            {[{
            icon: "👦",
            text: "Chicos de 1.º a 5.º de primaria"
          }, {
            icon: "🏠",
            text: "Familias que buscan reforzar matemática en casa"
          }, {
            icon: "👩‍🏫",
            text: "Docentes que buscan actividades diferentes"
          }, {
            icon: "📚",
            text: "Refuerzo escolar"
          }, {
            icon: "☀️",
            text: "Vacaciones"
          }, {
            icon: "🧠",
            text: "Práctica semanal"
          }].map((item, i) => <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.1
          }} key={i} className="bg-off-white pixel-border hard-shadow p-4 flex items-center gap-4" data-id="element-305" data-mp="3u0vxf1x5mlwj" data-mpi={i}>
                <span className="text-3xl" data-id="element-306" data-mp="gt2mfa5iv9qa">{item.icon}</span>
                <span className="font-body font-bold text-[#171717] text-base" data-id="element-307" data-mp="grhs9ln4dssy">{item.text}</span>
              </motion.div>)}
          </div>
        </section>

        {/* Pixel Divider */}
        

        {/* 11.5 CONOCÉ A LA CREADORA */}
        <section className="bg-sky-blue px-4 py-12 relative overflow-hidden text-center" style={{
        paddingTop: "0px",
        paddingBottom: "0px",
        paddingLeft: "4px",
        paddingRight: "8px"
      }} data-id="element-308" data-mp="1ycowjzy5fzd2">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="max-w-[600px] mx-auto bg-white pixel-border hard-shadow p-2 md:p-4 relative z-10" data-id="element-309" data-mp="2q4ejaaegt9mp">
            <img src={IMAGES.profeSofi} alt="Conocé a la Profe Sofi" className="w-full h-auto pixel-border" data-id="element-310" data-mp="2cdhqaigmmqf4" />
          </motion.div>
        </section>

        {/* Pixel Divider */}
        <div className="w-full flex flex-col relative z-10" data-id="element-311" data-mp="39ugg5u729prk">
          <div className="h-6 bg-grass-green border-y-4 border-[#111]" data-id="element-312" data-mp="350cbjhl9pttn"></div>
          <div className="h-6 bg-medium-brown border-b-4 border-[#111]" data-id="element-313" data-mp="3cduynjvskyvk"></div>
        </div>

        {/* 12. FAQ */}
        <section className="bg-off-white px-4 py-12 relative overflow-hidden" data-id="element-314" data-mp="3hcxx2lh9o6uk">
          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-body font-black text-[28px] md:text-[34px] text-[#171717] text-center mb-10 uppercase relative z-10" data-id="element-315" data-mp="3mazobtoujch4">
            PREGUNTAS FRECUENTES
          </motion.h2>
          
          <div className="flex flex-col gap-4 max-w-[95%] mx-auto relative z-10" data-id="element-316" data-mp="8xo17v3yzxv8">
            {faqs.map((faq, i) => <motion.details initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.1
          }} key={i} className="group bg-white pixel-border hard-shadow" data-id="element-317" data-mp="duwjrwt163x0" data-mpi={i}>
                <summary className="font-body font-black text-[16px] md:text-[18px] p-4 cursor-pointer flex justify-between items-center list-none uppercase text-[#171717]" data-id="element-318" data-mp="2ey74ex226er8">
                  <span className="pr-4" data-id="element-319" data-mp="2sqwoux1xvbm8">{faq.q}</span>
                  <span className="text-2xl group-open:rotate-180 transition-transform" data-id="element-320" data-mp="2nxk5p2g13x0v">▼</span>
                </summary>
                <div className="p-4 pt-0 font-body font-medium text-[15px] leading-[1.45] text-[#302A26] border-t-4 border-[#111]" data-id="element-321" data-mp="32lezyn9oq9g2">
                  {faq.a}
                </div>
              </motion.details>)}
          </div>
        </section>

        {/* Pixel Divider */}
        <div className="w-full flex flex-col relative z-10" data-id="element-322" data-mp="36q4ua7op3fyv">
          <div className="h-6 bg-medium-brown border-y-4 border-[#111]" data-id="element-323" data-mp="1h9n9allxl3q7"></div>
          <div className="h-6 bg-grass-green border-b-4 border-[#111]" data-id="element-324" data-mp="1hbq91xcvyb84"></div>
        </div>

        {/* 12. CTA FINAL */}
        <section className="bg-sky-blue px-4 py-16 text-center relative overflow-hidden" data-id="element-325" data-mp="3nyfk1s7nry2f">
          {/* Decorative Elements */}
          <GameDecoration type="torch" className="w-[30px] md:w-[50px] left-[5%] top-[30%] animate-torch-flicker" data-id="element-326" data-mp="3sw7asiwkhe51" />
          <GameDecoration type="torch" className="w-[30px] md:w-[50px] right-[5%] top-[30%] animate-torch-flicker" data-id="element-327" data-mp="3f5c9broedzbh" />
          <GameDecoration type="diamond" className="w-[40px] md:w-[60px] right-[20%] bottom-[30%] animate-game-float" data-id="element-328" data-mp="3j5mb0s55q3kj" />
          <GameDecoration type="grass-block" className="w-[40px] md:w-[50px] left-[10%] bottom-[-10px]" data-id="element-329" data-mp="3a6r7jnthz7kx" />
          <GameDecoration type="grass-block" className="w-[30px] md:w-[40px] left-[25%] bottom-[-5px]" data-id="element-330" data-mp="2w6zov9s1d30l" />
          <GameDecoration type="grass-block" className="w-[50px] md:w-[60px] right-[15%] bottom-[-15px]" data-id="element-331" data-mp="308bevgetnq9b" />

          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-body font-black text-[28px] md:text-[34px] text-[#171717] uppercase mb-6 leading-tight relative z-10" data-id="element-332" data-mp="uf3cxz1yhr5a">
            HOY PUEDE SER EL DÍA EN QUE PRACTICAR MATEMÁTICA DEJE DE SER UNA PELEA.
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="font-body font-bold text-[#171717] text-[16px] md:text-[18px] bg-white/80 px-4 py-2 pixel-border inline-block mb-10 max-w-[95%] relative z-10" data-id="element-333" data-mp="3vzv8d3z6y348">
            Transformá sus ejercicios en desafíos que realmente tenga ganas de completar.
          </motion.p>
          
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-off-white pixel-border hard-shadow p-6 max-w-[95%] mx-auto relative z-10" data-id="element-334" data-mp="339mo96l3h8n0">
            <img src={IMAGES.packCompleto} alt="Pack Completo" className="w-[95%] mx-auto mb-8 drop-shadow-xl" data-id="element-335" data-mp="1ip96w6oamj5i" />
            
            <div className="flex flex-col gap-3 mb-8" data-id="element-336" data-mp="1noc97jcw2b9s">
              <span className="bg-grass-green text-white font-body font-black pixel-border px-4 py-2 text-[18px] uppercase" data-id="element-337" data-mp="1snxeebinjfuy">+100 ACTIVIDADES</span>
              <span className="bg-yellow-pixel text-[#111] font-body font-black pixel-border px-4 py-2 text-[18px] uppercase" data-id="element-338" data-mp="100kq9wwuezzj">+ 5 BONOS GRATIS</span>
            </div>
            
            <div className="bg-dark-brown pixel-border p-4 md:p-6 text-center text-white mb-6" data-id="element-339" data-mp="14xkwq8xlu4r6">
              <div className="flex flex-col md:flex-row items-center justify-center gap-2 md:gap-6 mb-4" data-id="element-340" data-mp="19sgza30gwaij">
                <div className="flex flex-col items-center" data-id="element-341" data-mp="c95ukmzkngx9">
                  <p className="font-body font-bold text-gray-400 text-[16px] line-through mb-0" data-id="element-342" data-mp="h8s7evbhmv5j">Antes: $35.980</p>
                  <div className="bg-[#E53E3E] text-white font-body font-black px-2 py-0.5 pixel-border text-[14px] uppercase mt-1" data-id="element-343" data-mp="97u80n7kqlva">AHORRÁS 50%</div>
                </div>
                <p className="font-display text-4xl md:text-5xl text-yellow-pixel text-outline-sm uppercase leading-none" data-id="element-344" data-mp="iy5fgjqgvd6x">
                  <span className="text-[20px] block md:inline md:mr-2 text-white text-outline-none" data-id="element-345" data-mp="e0nf3hqim6aj">HOY</span>
                  $17.990 ARS
                </p>
              </div>
              <CTAButton data-id="element-346" data-mp="3ifdgjcamhprf" />
            </div>
          </motion.div>
        </section>
        
        {/* Footer */}
        <footer className="bg-[#111] text-gray-400 py-8 px-4 text-center font-body font-bold text-xs border-t-4 border-[#111] relative z-10" data-id="element-347" data-mp="aa8bipd0xms">
          <p className="mb-2" data-id="element-348" data-mp="1bnvtytw0gh3k">© {new Date().getFullYear()} Lectura Mundo Bloques. Todos los derechos reservados.</p>
          <p data-id="element-349" data-mp="16patqugrdxf4">Este producto no está asociado, afiliado, respaldado, certificado ni patrocinado por Mojang AB o Microsoft. Minecraft es una marca registrada de Mojang Synergies AB.</p>
        </footer>

      </div>
    </div>;
}